export const navLinks = [
  { label: "Story", href: "#story" },
  { label: "Trailer", href: "#trailer" },
  { label: "Pillars", href: "#pillars" },
  { label: "Media", href: "#media" },
  { label: "Roadmap", href: "#roadmap" },
  { label: "Help", href: "/help" },
] as const;
